const fileGetDataBeforePost = (file) => {
    return file.wasProcessedBefore
        ? file.originalPosition
        : file.id
}

export default fileGetDataBeforePost